import Api from "../../../../service";
import { SET_ERROR, SET_TEAMMATCHES, getKey } from "./constants";

const setTeamMatches = (data, key) => ({
  type: SET_TEAMMATCHES,
  data,
  key,
});

const setError = (data, key) => ({
  type: SET_ERROR,
  data,
  key,
});

export const getTeamMatches = (data) => (dispatch) =>
  Api.competition
    .getMatches(data)
    .then((response) => {
      dispatch(setTeamMatches(response, getKey(data)));
      return response;
    })
    .catch((error) => {
      console.error(error);
      dispatch(setError(error, getKey(data)));
    });
